export const FLOVATAR_COMPONENT_DEPOSIT =
  "A.921ea449dffec68a.FlovatarComponent.Deposit";
export const FLOVATAR_COMPONENT_WITHDRAW =
  "A.921ea449dffec68a.FlovatarComponent.Withdraw";
